import type { AnswerQuestionInputDto, EvaluationDto, EvaluationViewUpdateDto, FinishEvaluationInputDto, PagedRequestEvaluationDto, SelfEvaluationAvailabilityDto, SelfEvaluationContextDto, StartEvaluationInputDto, StartEvaluationOutputDto, StartSelfEvaluationInputDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { AnswerDto } from '../answers/models';
import type { OperatorEvaluationSummaryDto, PagedOperatorEvaluationSummaryInputDto } from '../operator-evaluation-summaries/models';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class EvaluationService {
  apiName = 'Default';
  

  answerQuestionByInput = (input: AnswerQuestionInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, AnswerDto>({
      method: 'POST',
      url: '/api/app/evaluation/answer-question',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  deleteAnswerQuestionByQuestionConfigurationItemIdAndEvaluationInstanceId = (questionConfigurationItemId: number, evaluationInstanceId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, EvaluationViewUpdateDto>({
      method: 'DELETE',
      url: '/api/app/evaluation/answer-question',
      params: { questionConfigurationItemId, evaluationInstanceId },
    },
    { apiName: this.apiName,...config });
  

  finishEvaluationByInput = (input: FinishEvaluationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/evaluation/finish-evaluation',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getAllEvaluationsByInputAndIsCurrentUserEvaluator = (input: PagedRequestEvaluationDto, isCurrentUserEvaluator: boolean, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<EvaluationDto>>({
      method: 'GET',
      url: '/api/app/evaluation/evaluations',
      params: { evaluateeId: input.evaluateeId, evaluateeName: input.evaluateeName, state: input.state, startDate: input.startDate, endDate: input.endDate, areaId: input.areaId, subAreaId: input.subAreaId, shiftId: input.shiftId, types: input.types, isOperatorEvaluationSummaryFlow: input.isOperatorEvaluationSummaryFlow, skipCount: input.skipCount, maxResultCount: input.maxResultCount, isCurrentUserEvaluator },
    },
    { apiName: this.apiName,...config });
  

  getAllOperatorEvaluationSummaryByInput = (input: PagedOperatorEvaluationSummaryInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OperatorEvaluationSummaryDto>>({
      method: 'GET',
      url: '/api/app/evaluation/operator-evaluation-summary',
      params: { evaluateeName: input.evaluateeName, areaId: input.areaId, subAreaId: input.subAreaId, shiftId: input.shiftId, evaluationState: input.evaluationState, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getEvaluationInstanceByIdByEvaluationInstanceId = (evaluationInstanceId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, EvaluationViewUpdateDto>({
      method: 'GET',
      url: `/api/app/evaluation/evaluation-instance-by-id/${evaluationInstanceId}`,
    },
    { apiName: this.apiName,...config });
  

  getSelfEvaluationAvailabilityByInput = (input: StartSelfEvaluationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SelfEvaluationAvailabilityDto>({
      method: 'GET',
      url: '/api/app/evaluation/self-evaluation-availability',
      params: { areaId: input.areaId, subAreaId: input.subAreaId },
    },
    { apiName: this.apiName,...config });
  

  getSelfEvaluationContext = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, SelfEvaluationContextDto>({
      method: 'GET',
      url: '/api/app/evaluation/self-evaluation-context',
    },
    { apiName: this.apiName,...config });
  

  hasEvaluationWithinPeriodBySubareaByOperatorIdAndSubAreaId = (operatorId: number, subAreaId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/app/evaluation/has-evaluation-within-period-by-subarea',
      params: { operatorId, subAreaId },
    },
    { apiName: this.apiName,...config });
  

  startEvaluationByInput = (input: StartEvaluationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StartEvaluationOutputDto>({
      method: 'POST',
      url: '/api/app/evaluation/start-evaluation',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  startSelfEvaluationByInput = (input: StartSelfEvaluationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StartEvaluationOutputDto>({
      method: 'POST',
      url: '/api/app/evaluation/start-self-evaluation',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
